
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";

interface ResetPasswordDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  errorMessage: string;
}

export const ResetPasswordDialog = ({
  open,
  onOpenChange,
  errorMessage,
}: ResetPasswordDialogProps) => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate("/auth?mode=forgot-password");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-red-500" />
            Password Reset Error
          </DialogTitle>
          <DialogDescription>
            {errorMessage || "There was a problem processing your password reset request."}
          </DialogDescription>
        </DialogHeader>
        <div className="bg-red-50 p-4 rounded-md text-sm text-red-800 my-2">
          <p>This may happen if:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1">
            <li>Your reset link has expired</li>
            <li>You've already used this reset link</li>
            <li>There's an issue with your reset token</li>
          </ul>
        </div>
        <DialogFooter>
          <Button onClick={() => navigate("/auth")} variant="outline">
            Back to Login
          </Button>
          <Button onClick={handleRetry}>
            Try Again
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
